import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Printer, X } from "lucide-react";
import { issuePrintLink, printUrl } from "../../../api/docPrint";

const KIND = { purchase_order: "purchase_order", bill: "purchase_bill" };

// شريط سفلي ثابت ممتد لعرض الشاشة — إغلاق + طباعة التقرير.
export const DetailFooter = ({ doc, backTo }) => {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const kind = KIND[doc.doc_type];

  const print = async () => {
    if (!kind) return;
    setBusy(true);
    try {
      const link = await issuePrintLink(kind, doc.id);
      window.open(printUrl(link), "_blank", "noopener");
    } catch (e) {
      toast.error(e?.response?.data?.detail?.code || t("errors.generic"));
    } finally { setBusy(false); }
  };

  return (
    <footer dir="rtl"
      className="flex shrink-0 items-center justify-between gap-3 border-t border-border/60 bg-background px-4 py-3 sm:px-8 lg:px-12"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
      data-testid="po-detail-footer">
      {kind ? (
        <button data-testid="po-detail-print" disabled={busy} onClick={print}
                className="inline-flex items-center gap-2 rounded-xl bg-slate-800 px-5 py-2.5 text-xs font-bold text-white shadow-neu-sm hover:brightness-110 disabled:opacity-50">
          <Printer className="h-3.5 w-3.5" /> {t("purchases.podetail.printReport")}
        </button>
      ) : <span />}
      <button data-testid="po-detail-close"
              onClick={() => (backTo ? nav(backTo) : nav(-1))}
              className="inline-flex items-center gap-2 rounded-xl border border-border/60 bg-background px-5 py-2.5 text-xs font-bold shadow-neu-sm hover:bg-muted">
        <X className="h-3.5 w-3.5" /> {t("purchases.podetail.close")}
      </button>
    </footer>
  );
};
